import { StarTwoTone } from '@ant-design/icons';
import React from 'react';

// comman function for capsule
import { getRandomLightHexColor } from '../../helpers/functions';

// import img from '../../assets/images/myImgs/dollar-1159943_1280.png';

function Capsule({ item, handleCapsuleClickEvent, localData, icons, isIconDisplay, step }) {
  let selected = false;
  if (localData && localData !== '' && typeof localData === 'object') {
    Object.values(localData).forEach(element => {
      if (typeof element === 'object' && element?.id === item?.id && element?.name === item?.name) {
        selected = true;
      }
      
    });
  }
  let iconPath = (isIconDisplay && icons?.[item?.name.replace(/\s+/g, '').toLowerCase()]) || null;

  return (
    <span
      className="capsule"
      style={{
        borderColor: selected ? 'transparent' : item.name == 'Looking For Something Else?' ? "red": getRandomLightHexColor(160, 230),
        borderWidth: selected ? '5px' : '3px',
        backgroundColor: selected ? item.name == 'Looking For Something Else?' ? "red" : '#1c64f2' : 'transparent',
        color: selected ? 'white' : item.name == 'Looking For Something Else?' ? "red" : 'black',
      }}
    >
      <button
        type="button"
        style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}
        onClick={() => handleCapsuleClickEvent(item)}
      >
        <div className="capsule_text" style={{ fontWeight: selected ? 'bold' : 'normal' }}>
          {item?.name === 'Bookkeeping' && (
            <img
              height={40}
              src={require('../../assets/images/questions_icons/Bookkeeping.png')}
              alt="Bookkeeping"
              loading="lazy"
            />
          )}
          {item?.name === 'Payroll Management' && (
            <img
              height={40}
              src={require('../../assets/images/questions_icons/staff.png')}
              alt="Staff"
              loading="lazy"
            />
          )}
          {item?.name === 'Accounting' && (
            <img
              height={40}
              src={require('../../assets/images/questions_icons/accounting.png')}
              alt="Accounting"
              loading="lazy"
            />
          )}
          {item?.name === 'Business Analysis' && (
            <img
              height={40}
              src={require('../../assets/images/questions_icons/chart.png')}
              alt="Business analysis"
              loading="lazy"
            />
          )}
          {item?.name === 'Tax Services' && (
            <img
              height={40}
              src={require('../../assets/images/questions_icons/dollar.png')}
              alt="Tax Preparation"
              loading="lazy"
            />
          )}
          {item?.name === 'Business Financing' && (
            <img
              height={40}
              src={require('../../assets/images/questions_icons/business_financing.png')}
              alt="Business Financing"
              loading="lazy"
              
            />
          )}
          {' ' + item?.name || 'N/A'}
        </div>
      </button>
    </span>
  );
}

export default Capsule;
